import { EventType } from './eventBus'

export class NotificationsCore {
  constructor(store, eventBus, enabled, types) {
    this.store = store
    this.eventBus = eventBus
    this.enabled = enabled
    this.types = types
  }

  async fetchAllMessages(emitEvent = true) {
    await this.store.dispatch('fetchAllMessages', { emitEvent, types: this.types })
  }
  async fetchUnreadMessages(emitEvent = true) {
    await this.store.dispatch('fetchUnreadMessages', { emitEvent, types: this.types })
  }

  get allMessages() {
    return this.store.getters.getMessages
  }

  get unreadMessages() {
    if (!this.unreadMessagesCount) {
      return []
    }
    return this.store.getters.getMessages.filter(x => !x.isRead || x.flagged).sort((a, b) => b.id - a.id)
  }

  get unreadMessagesCount() {
    return this.store.getters.getMessages.filter(x => !x.isRead).length
  }

  get notificationsIsEnabled() {
    return this.enabled
  }

  markMessageAsRead(item) {
    if (item.isRead) {
      return
    }
    this.store.commit('MARK_MESSAGE_AS_READ', item.id)
  }

  markAllMessagesAsRead() {
    this.store.commit('MARK_ALL_MESSAGE_AS_READ')
  }

  onNotificationReceive(eventHandler) {
    this.eventBus.$on(EventType.NOTIFICATION_RECEIVE, eventHandler)
  }
}
